import { type Loadable } from '@/loadingUtils'
import type { Study } from '@pocketprep/types'

interface IAssignmentModuleState {
    currentOrgAssignments: { [orgId: string]: Loadable<{
        [assignmentId: string]: Study.Class.PrebuiltQuizJSON
    }> }
    currentOrgDifficultyCounts: { [orgId: string]: Loadable<{
        [subjectId: string]: { easy: number; medium: number; hard: number }
    }> }
    createdAssignment: Study.Class.PrebuiltQuizJSON | null
}

export const getInitialAssignmentState = (): IAssignmentModuleState => {
    return {
        currentOrgAssignments: {},
        currentOrgDifficultyCounts: {},
        createdAssignment: null,
    }
}

const moduleState = getInitialAssignmentState()

export default moduleState
